import { createFileRoute } from "@tanstack/react-router";

import { AccountSettingsPage } from "~/components/settings/account-settings-page";

export const Route = createFileRoute("/_authenticated/settings/account/$")({
  component: AccountSettingsPage,
});
